import { render, staticRenderFns } from "./screen-area.vue?vue&type=template&id=c719bdc6&scoped=true"
import script from "./screen-area.vue?vue&type=script&lang=js"
export * from "./screen-area.vue?vue&type=script&lang=js"
import style0 from "./screen-area.vue?vue&type=style&index=0&id=c719bdc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c719bdc6",
  null
  
)

export default component.exports